import { Button } from '@predoc/cow';
import { LogOut, ShieldX } from 'lucide-react';
import { useAuth } from '@/routes/AuthContext';

export const NoAccessPage = () => {
  const { handleSignOut } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
          <ShieldX className="h-8 w-8 text-red-600" />
        </div>

        <h1 className="mb-2 text-2xl font-bold text-gray-900">Access Denied</h1>

        <p className="mb-6 text-gray-600">
          You don&apos;t have permission to access this page.
          <br />
          Please contact your administrator to get access.
        </p>

        <Button
          onClick={() => void handleSignOut()}
          variant="outline"
          className="gap-2"
        >
          <LogOut className="h-4 w-4" />
          Log out
        </Button>
      </div>
    </div>
  );
};
